// External Dependencies
import firebase from 'firebase';

// Firebase keys
const config = {
  apiKey: 'AIzaSyB1Dfie5ty899eZaXpksFxx5uBCBTaW3z8',
  authDomain: 'frisco-coder-dojo-restore.firebaseapp.com',
  databaseURL: 'https://frisco-coder-dojo-restore.firebaseio.com',
};

firebase.initializeApp(config);

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const firebaseRef = firebase.database().ref();
export default firebase;



/** WEBPACK FOOTER **
 ** ./src/config/constants.js
 **/